import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { getRestaurantProductListApi, removeProductPostApi } from '../../../Api/PanelAdminServices'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import FoodsListTabel from '../../Tables/FoodsListTabel/FoodsListTabel'
import { Modal } from "react-bootstrap";
import EditResturanFoodForm from '../../Forms/EditResturanFoodForm/EditResturanFoodForm'
import { errorToast, succToast } from '../../../Utils/Toast/Toast'
import Button from '../../Button/Button'
const ResturansFoodContainer = () => {
  const[foodsListState,setFoodsListState]=useState(null)
  const[ShowModalState,setShowModalState]=useState(false)
  const[ProductInfoState,setProductInfoState]=useState(null)
  const[rawInfo,setRawInfo]=useState([])
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [disable, setDisable] = useState(false);
  useEffect(()=>{
    getFoodsListHandler()
  },[])
  const getFoodsListHandler=async()=>{
    getRestaurantProductListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          res.products.sort((a)=>{
            if (a.packed==="0"){
              return -1
            }
          })
          setFoodsListState(res.products)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  const showModal=(id,value)=>{
    ///////edit/////////
    if(id===1){
      setShowModalState(true)
      setProductInfoState(value)
    }
    ////Delete/////
    if (id === 2) {
      setDeleteVisible(true);
      setRawInfo(value)
    }
  }
  const removeProduct=()=>{
    setDisable(true)
    let info={
      id:rawInfo.ProductId
    }
    removeProductPostApi(info,res=>{
      if(res.status===1){
        succToast(res.message)
        setDisable(false)
      }else{
        errorToast(res.message)
        setDisable(false)
      }
    })
    setDeleteVisible(false);
    getFoodsListHandler()
  }
  const handleOk = () => {
    setShowModalState(false);
  };
  const updateData=()=>{
    handleOk()
    getFoodsListHandler()
  }
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از حذف کردن محصول مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOk}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={removeProduct}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={ShowModalState} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={{textAlign:'right',width:'100%',fontSize:'1rem'}}>
            ویرایش محصول
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditResturanFoodForm info={ProductInfoState} updateData={updateData}/>
        </Modal.Body>
      </Modal>
        <TableFixedPage title="لیست غذاهای رستوران" />
        <FoodsListTabel data={foodsListState} openModal={showModal}/>
    </div>
  )
}

export default ResturansFoodContainer